import { Locale } from "@omni/types/enums/locale.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { getLanguageTag } from "@omni/utils/locale.utils";
import { useEffect, useState } from "react";

import { Config } from "@/utils/config.utils";

type StoreDistanceComponentProps = {
    distancePromise: Promise<undefined | number>;
};

export const formatDistance = (
    distance: number | undefined,
    locale?: Locale
) => {
    if (!isDefined(distance)) return;

    const languageTag = locale
        ? getLanguageTag(locale)
        : Config.getLanguageTag();

    // Distance in metres -> Convert to km and round to .1
    const roundedDistance = Math.round(distance / 100) / 10;

    const localizedDistance = new Intl.NumberFormat(languageTag, {
        useGrouping: false
    }).format(roundedDistance);

    return `${localizedDistance} km`;
};

export const StoreDistanceComponent = ({
    distancePromise
}: StoreDistanceComponentProps) => {
    const [distance, setDistance] = useState<undefined | number>(undefined);

    useEffect(() => {
        if (!distancePromise) return;
        distancePromise.then(setDistance);
    }, [distancePromise]);

    const formattedDistance = formatDistance(distance);

    if (!isDefined(distance)) return null;

    return (
        <span className={"font-weight-normal small ml-3"}>
            {formattedDistance}
        </span>
    );
};
